export default __webpack_public_path__ + "static/Sailec-Medium-d481891c4acd5cd48e2d14efa03205f8.woff2";